import React, { Component } from 'react';
import ClipboardButton from 'react-clipboard.js';
import { browserHistory } from 'react-router';

import { MEDIA_STATUS } from 'src/common/types/media';

import { getExperiment } from '../../utils/get-experiment';
import UpgradeModal from './UpgradeModal';
import './fileList.css';

class FileListItem extends Component {
  constructor() {
    super();

    this.state = {
      copied: false,
    };
  }

  render() {
    const { name, description, downloadUrl, rawUrl, me } = this.props;
    const noTrial = getExperiment('noFreeTrials') ? true : me.no_trial;

    return (
      <div className="file-list-item">
        <UpgradeModal
          isOpen={this.state.modalOpen}
          onClose={() => this.setState({ modalOpen: false })}
          darkMode={me.dark_mode}
          noTrial={noTrial}
          header="Streamable Basic Required"
          subheader="Upgrade now to access MP4 video URLs."
          srcInternal="mp4url"
        />
        <div className="name">{name}</div>
        <div className="description">{description}</div>
        {downloadUrl ? (
          <span>
            <a
              href="#"
              className="lastcell file-list-button"
              onClick={(e) => {
                e.preventDefault();
                const a = document.createElement('A');
                a.href = downloadUrl;
                a.download = downloadUrl.substr(
                  downloadUrl.lastIndexOf('/') + 1
                );
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
              }}
            >
              Download
            </a>
            {me.plan ? (
              <ClipboardButton
                component="a"
                data-clipboard-text={rawUrl}
                onSuccess={() => {
                  this.setState({ copied: true });
                  setTimeout(() => {
                    this.setState({ copied: false });
                  }, 3000);
                }}
              >
                {this.state.copied ? (
                  <span className="lastcell file-list-button copied">
                    Copied
                  </span>
                ) : (
                  <span className="lastcell file-list-button">
                    Copy MP4 URL
                  </span>
                )}
              </ClipboardButton>
            ) : (
              <span
                className="lastcell file-list-button"
                onClick={() => this.setState({ modalOpen: true })}
              >
                Copy MP4 URL
              </span>
            )}
          </span>
        ) : (
          <span className="lastcell processing">Processing ...</span>
        )}
      </div>
    );
  }
}

export default class PrivacySettings extends Component {
  render() {
    const { video, me } = this.props;
    const mobileDone =
      video.files['mp4-mobile'] &&
      video.files['mp4-mobile'].status == MEDIA_STATUS.READY;
    const mp4Done =
      video.files['mp4'] && video.files['mp4'].status == MEDIA_STATUS.READY;
    const ultraDone =
      video.files['mp4-high'] &&
      video.files['mp4-high'].status == MEDIA_STATUS.READY;
    const isHd =
      video.files['mp4'] &&
      video.files['mp4'].height &&
      video.files['mp4'].height > 480;
    const isPro = !!me.plan;

    return (
      <div className="file-list">
        {video.waiting_for_best || ultraDone ? (
          <FileListItem
            name="Super HD"
            description={
              ultraDone
                ? `${video.files['mp4-high'].width} × ${
                    video.files['mp4-high'].height
                  } / ${(video.files['mp4-high'].size / 1000000).toFixed(1)}MB`
                : ''
            }
            downloadUrl={ultraDone ? video.files['mp4-high'].url : null}
            rawUrl={`https://streamable.com/l/${video.shortcode}/mp4-high.mp4`}
            me={me}
          />
        ) : (
          ''
        )}
        <FileListItem
          name={isHd ? 'HD' : 'SD'}
          description={
            mp4Done
              ? `${video.files['mp4'].width} × ${
                  video.files['mp4'].height
                } / ${(video.files['mp4'].size / 1000000).toFixed(1)}MB`
              : ''
          }
          downloadUrl={mp4Done ? video.files['mp4'].url : null}
          rawUrl={`https://streamable.com/l/${video.shortcode}/mp4.mp4`}
          me={me}
        />
        {isHd ? (
          <FileListItem
            name="SD"
            description={
              mobileDone
                ? `${video.files['mp4-mobile'].width} × ${
                    video.files['mp4-mobile'].height
                  } / ${(video.files['mp4-mobile'].size / 1000000).toFixed(
                    1
                  )}MB`
                : ''
            }
            downloadUrl={mobileDone ? video.files['mp4-mobile'].url : null}
            rawUrl={`https://streamable.com/l/${video.shortcode}/mp4-mobile.mp4`}
            me={me}
          />
        ) : (
          ''
        )}
        {isHd && !isPro ? (
          <div className="alert alert-info">
            Need a higher resolution?
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                browserHistory.replace('/upgrade?src_internal=download');
              }}
            >
              Upgrade now
            </a>
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }
}
